export default function formatAreaUnit(areaUnit) {
  if (!areaUnit) return;

  const types = {
    alqueire: "alq",
    hectare: "ha",
    metros: "m²",
  };

  return types[areaUnit];
}
